import pathToRegexp from 'path-to-regexp'
import * as R from 'ramda'
import { parse, format } from 'url'
import config from 'config'

import { checkIfOnPageElseRedirect } from 'src/lib/util/url'

const adminRoutes = [
  'activity',
  'admin',
  'admin/communities',
  'admin/members',
  'admin/organizations',
  'admin/settings',
  'admin/lti3/integrations'
]
const accessRoutes = ['invitation']

export function networkUrl(networkName, path = '') {
  const parsedBase = parse(config.NEXT_PUBLIC_YD_URL)
  const parsedPath = parse(path)

  return format({
    ...parsedBase,
    host: `${parsedBase.host}/n/${networkName}`,
    pathname: parsedPath.search ? parsedPath.pathname : path,
    search: parsedPath.search
  })
}

export function switchNetwork(network, pathname = '') {
  const name = network[':network/name']
  return networkUrl(name, pathname)
}

function isAdminRoute(pageURL) {
  if (pageURL) {
    adminRoutes.forEach(r => {
      const re = pathToRegexp('/organization/admin' + r)
      const match = re.exec(pageURL)

      if (match) {
        return true
      }
    })
  }
  return false
}

function isAccessRoute(pageURL) {
  if (pageURL) {
    accessRoutes.forEach(r => {
      const re = pathToRegexp('/organization/admin' + r)
      const match = re.exec(pageURL)

      if (match) {
        return true
      }
    })
  }
  return false
}

function userHasAdminAccess(networkAccessInfo) {
  return (
    networkAccessInfo.userIsNetworkAdmin || networkAccessInfo.userIsNetworkOwner
  )
}

export function checkNetworkAccess(network, pageURL) {
  if (!network) {
    return '/not-found'
  }

  const networkName = network[':network/name']

  const networkAccessInfo = network['@network/access-info']
  const isAdminPage = isAdminRoute(pageURL)
  const isAccessPage = isAccessRoute(pageURL)
  const adminAccess = userHasAdminAccess(networkAccessInfo)
  const canViewNetworkPage =
    adminAccess || R.and(networkAccessInfo.userInNetwork, !isAccessPage)

  // @TODO this checks looks redundant because we are returning /not-found as default
  const cannotViewNetworkPage = R.and(
    isAdminPage,
    R.and(!networkAccessInfo.hasPendingInvite, !adminAccess)
  )
  const canViewInvitationPage = networkAccessInfo.hasPendingInvite
  const hasPendingBoardInvite = networkAccessInfo.hasPendingBoardInvite

  if (canViewInvitationPage) {
    const redirectUrl = checkIfOnPageElseRedirect(
      '/organization/invitation',
      pageURL
    )

    return redirectUrl ? `/n/${networkName}${redirectUrl}` : undefined
  }

  if (
    hasPendingBoardInvite &&
    network['@network/pending-network-board-invitations']
  ) {
    const [boardInvitation] =
      network['@network/pending-network-board-invitations']
    const boardUuid = R.prop(
      ':board/squuid',
      boardInvitation[':invitation/board']
    )
    return `/n/${networkName}/community/${boardUuid}/invitation`
  }

  if (canViewNetworkPage) {
    return
  }

  if (cannotViewNetworkPage) {
    return '/not-found'
  }

  return '/not-found'
}
